class Seo {
  constructor(ctx) {
    this.ctx = ctx
  }

  get canonicalUrl() {
    const host = this.ctx.req ? this.ctx.req.headers.host : window.location.host
    return 'https://' + host
  }

  setMeta(title, content, mainConfig){
    const finalContent =  content || mainConfig 
    if(!finalContent) return {}
    return { hid:title, name:title, content: finalContent }
  }

  twitterMetas(content, mainConfig, canonical){
    const twDefaultTitle = content?.title ||  mainConfig.metaTwitterTitle
    const twDefaultDescription = content?.descriptionPage ||  mainConfig.metaTwitterDescription
    return [
      this.setMeta('twitter:title',content?.title,twDefaultTitle),
      this.setMeta('twitter:description',content?.descriptionPage, twDefaultDescription),
      this.setMeta('twitter:card',content?.twitter?.summary, mainConfig.metaTwitterSummary),
      this.setMeta('twitter:site',content?.twitter?.site, mainConfig.metaTwitterSite),
      this.setMeta('twitter:creator',content?.twitter?.creator, mainConfig.metaTwitterCreator),
      this.setMeta('twitter:url',content?.twitter?.url, canonical),
      {
        hid: 'twitter:image:src',
        name: 'twitter:image:src',
        content: 'https://assets.nh-hotels.net/bookingManagement/system/nhGroup/v3/html/img/favicons/favicon-192x192.png'
      },
    ]
  }

  facebookMetas(content,mainConfig){
    const fbDefaultTitle = content?.title ||  mainConfig.metaFacebookTitle
    const fbDefaultDescription = content?.descriptionPage ||  mainConfig.metaFacebookDescription
    return [
      this.setMeta('og:title',content?.facebook?.title, fbDefaultTitle ),
      this.setMeta('og:description',content?.facebook?.descr, fbDefaultDescription ),
      this.setMeta('og:site_name',content?.facebook?.site, mainConfig.metaFacebookSitename ),
      this.setMeta('og:locale',content?.facebook?.lang, mainConfig.metaFacebookLang ),
      this.setMeta('og:locale:alternate',content?.facebook?.altLang, mainConfig.metaFacebookAltLang )
    ]
  }

  googleMetas(content,mainConfig){
    const gplusTitle = content?.title || content?.gplus?.title || mainConfig.metaGooglePlusTitle
    const gplusDescription = content?.descriptionPage || content?.gplus?.description|| mainConfig.gplusDescription  // no existe gplusDescription
    return [
      this.setMeta('itemprop:name',content?.twitter?.title, gplusTitle ),
      this.setMeta('itemprop:description',content?.twitter?.description, gplusDescription),
    ]
  }

  itunesMeta(content, mainConfig){
    return [
      this.setMeta("apple-itunes-app", content?.itunes, mainConfig.metaItunes)
    ]
  }

  mountedSeo(seo) {
    const mainConfig = this.ctx.store.getters['pages/getMainConfig']() || {}
    const canonical = `${this.canonicalUrl}${this.ctx.route.path}`
    const content = seo?.regions?.IdentificationV3Region ? seo?.regions?.IdentificationV3Region[0].content : {}
    const defaultMetas = [
      { hid: 'description', name: 'description', content: content?.descriptionPage },
      { hid: 'og:url', property: 'og:url', content: canonical },
      { hid: 'og:image', property: 'og:image', content: '' },
      { hid: 'og:type', property: 'og:type', content: seo?.meta['og:type'] },
      { hid: 'robots', name: 'robots', content: seo?.meta?.robots },
      {
        hid: 'itemprop:image',
        name: 'itemprop:image',
        content: 'https://assets.nh-hotels.net/bookingManagement/system/nhGroup/v3/html/img/favicons/favicon-192x192.png'
      },
    ]
    const twitterDefault = this.twitterMetas(content, mainConfig, canonical)
    const facebookDefault = this.facebookMetas(content, mainConfig)
    const googleDefault =  this.googleMetas(content, mainConfig)
    const itunesDefault = this.itunesMeta(content,mainConfig)
    const metas = [...defaultMetas, ...twitterDefault, ...facebookDefault, ...googleDefault, ...itunesDefault]
    return {
      title: content?.titlePage ? content?.titlePage : seo?.title ? seo?.title : undefined,
      meta:[...metas],
    }
  }
}

export default (ctx, inject) => {
  inject('seo', new Seo(ctx))
}
